export default "__VITE_ASSET__7d7359ef__"